export default "__VITE_ASSET__DsrEm8XZ__"